import { all, fork } from 'redux-saga/effects';
import { watchCreateSprintInProjectTemplateSaga } from './create';
import { watchDeleteSprintInProjectTemplateSaga } from './delete';
import { watchUpdateSprintInProjectTemplateSaga } from './update';
export function* sprintTemplateRootSaga() {
    yield all([
        fork(watchUpdateSprintInProjectTemplateSaga),
        fork(watchDeleteSprintInProjectTemplateSaga),
        fork(watchCreateSprintInProjectTemplateSaga)
    ]);
}
